module.exports = __webpack_public_path__ + "static/img/m_role.ebb0af0.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/jw/m_role.png
// module id = oEd2
// module chunks = 7